// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1pwU2","upload":"Small_upload__2IE7a","imageWrap":"Small_imageWrap__3oTv2","removeBtn":"Small_removeBtn__3PgCQ"};